import React from 'react';
import { LoadingSpinner } from '../LoadingSpinner';

interface NotificationCountProps {
  loading?: boolean;
  count?: number;
}
const NotificationCount = ({
  loading = false,
  count,
}: NotificationCountProps) => {
  if (loading) {
    return (
      <div
        className="notification-badge-loading"
        style={{ transform: 'scale(0.4)' }}
      >
        <LoadingSpinner color="#FFFFFF" showText="" />
      </div>
    );
  }
  return count ? (
    <div className="notification-badge" id="badge">
      {count}
    </div>
  ) : (
    <></>
  );
};

export default NotificationCount;
